// extracted by mini-css-extract-plugin
module.exports = {"Social":"NavBar1_Social__26D_d","Account":"NavBar1_Account__3tc25","Navbar":"NavBar1_Navbar__1btGy"};